import { useDispatch, useSelector } from 'react-redux';
import { useTour } from '@reactour/tour';

import { useEffect } from 'react';
import { selectUserOnboarding, updateUserOnboarding } from '../../../features/User/userSlice';

// Wrapper per il contenuto del TourProvider
export default function TourWrapper({ children }) {
  const dispatch = useDispatch();

  const { currentStep, meta, steps } = useTour();
  const userOnboarding = useSelector(selectUserOnboarding)

  // Funzione per gestire il cambio di step
  const handleStepChange = (step) => {
    if( (!userOnboarding && meta ) || 
        (userOnboarding && userOnboarding[meta] && (!userOnboarding[meta]?.step_completed_count || userOnboarding[meta]?.step_completed_count < currentStep))){
        dispatch(
            updateUserOnboarding({
                onboarding_step: {
                    step_completed_count: step,
                    section_completed: step === steps?.length -1,
                    section: meta
                }
            })
        );
    }
    
  };

  // Effetto per ascoltare i cambiamenti di step
  useEffect(() => {
    if (currentStep !== undefined) {
      handleStepChange(currentStep);
    }
  }, [currentStep]);

  return <>{children}</>;
}